module.exports = __webpack_public_path__ + "img/fuchi.eebccbbc.png";